var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddtick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.4H9.5C9.09 11.4 8.75 11.06 8.75 10.65C8.75 10.24 9.09 9.89999 9.5 9.89999H14.5C14.91 9.89999 15.25 10.24 15.25 10.65C15.25 11.06 14.91 11.4 14.5 11.4Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.96C11.59 13.96 11.25 13.62 11.25 13.21V8.20999C11.25 7.79999 11.59 7.45999 12 7.45999C12.41 7.45999 12.75 7.79999 12.75 8.20999V13.21C12.75 13.62 12.41 13.96 12 13.96Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0698 22.75C18.5598 22.75 17.9998 22.6 17.4598 22.29L12.5798 19.58C12.2898 19.42 11.7198 19.42 11.4298 19.58L6.54982 22.29C5.55982 22.84 4.54982 22.9 3.77982 22.44C3.00982 21.99 2.56982 21.08 2.56982 19.95V5.86C2.56982 3.32 4.63982 1.25 7.17982 1.25H16.8298C19.3698 1.25 21.4398 3.32 21.4398 5.86V19.95C21.4398 21.08 20.9998 21.99 20.2298 22.44C19.8798 22.65 19.4798 22.75 19.0698 22.75ZM11.9998 17.96C12.4698 17.96 12.9298 18.06 13.2998 18.27L18.1798 20.98C18.6898 21.27 19.1598 21.33 19.4598 21.15C19.7598 20.97 19.9298 20.54 19.9298 19.95V5.86C19.9298 4.15 18.5298 2.75 16.8198 2.75H7.17982C5.46982 2.75 4.06982 4.15 4.06982 5.86V19.95C4.06982 20.54 4.23982 20.98 4.53982 21.15C4.83982 21.32 5.30982 21.27 5.81982 20.98L10.6998 18.27C11.0698 18.06 11.5298 17.96 11.9998 17.96Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtick);
export default __webpack_public_path__ + "static/media/addtick.dec9a4cc0c24cc3bde97155121dce1d5.svg";
export { ForwardRef as ReactComponent };